<template>
  <div class="form-discuss-content">
    <div class="discuss-content" ref="discussContent" @click="hideInputEditor($event)">
      <div class="discuss" v-for="item in discuss" :key="item.id">
        <div class="header">
          <span class="creator" :title="item.fromName">{{item.fromName}}</span>
          <span v-if="item.from === currentUserId" class="delete" @click="deleteDiscuss(item.id)">删除</span>
        </div>
        <div class="content">{{item.text}}
          <div class="content-image">
            <div class="content-image-modal"></div>
            <span class="img-name">{{item.fileName}}</span>
            <el-image
              v-if="item.hasImage"
              @click="previewImage(item.fileUrl)"
              style="width: 250px; height: 150px;"
              fit="contain"
              :src="item.fileUrl">
            </el-image>
          </div>
          <div class="content-attachment" v-if="item.hasAttachment">
            <i class="fa fa-paperclip"></i>
            <span class="content-attachment-filename">{{item.fileName}}</span>
            <span class="content-attachment-filesize">{{item.fileSize}}MB</span>
            <i class="el-icon-bottom" @click="downloadAttachment(item.fileUrl)"></i>
          </div>
        </div>
        <div class="date">{{item.createdDate}}</div>
      </div>
      <div class="discuss-empty" v-if="discuss.length === 0">
        <img src="../assets/discuss-log-empty.png">
        <span>暂无讨论</span>
      </div>
      <div :class="['discuss-input', inputVisible && 'discuss-input-editor', editorFocus && 'discuss-input-editor-focus']">
        <el-input v-show="!inputVisible" class="input" @click.native="showInputEditor" placeholder="发表评论（按 ctrl + Enter 快速发表）"></el-input>
        <div ref="inputEditor" class="input-editor"
             v-show="inputVisible"
             contenteditable="true"
             @focus="inputEditorFocus"
             @blur="getAnchorRange($event)"
             @keydown.ctrl.enter.exact="postMsg">
        </div>
        <!-- mousedown的触发优先级比blur高， blur不会冒泡，这里不要改成click事件, prevent阻止点击工具栏的时候输入框失焦 -->
        <div class="input-editor-tools" v-show="inputVisible" @click="clickToolBar">
          <div class="tools">
            <!--表情-->
            <el-popover
              popper-class="emoji-popover"
              :close-delay="1000"
              placement="top"
              v-model="emojiVisible">
              <v-emoji-picker @select="selectEmoji"></v-emoji-picker>
              <span slot="reference" @click="emojiVisible = true"><i class="fa fa-smile-o"></i>表情</span>
            </el-popover>
            <!-- 图片 -->
            <el-upload
              class="discuss-upload"
              action=""
              :multiple="false"
              :on-change="(file) => changeFile(file, 'image')"
              :auto-upload="false"
              :show-file-list="false"
              :http-request="uploadFile">
              <span slot="trigger"><i class="fa fa-image"></i>图片</span>
            </el-upload>
            <!-- 附件 -->
            <el-upload
              class="discuss-upload"
              action=""
              :multiple="false"
              :on-change="(file) => changeFile(file, 'attach')"
              :auto-upload="false"
              :show-file-list="false">
              <span slot="trigger"><i class="fa fa-paperclip"></i>附件</span>
            </el-upload>
          </div>
          <el-button type="primary" @click="postMsg">发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { VEmojiPicker } from 'v-emoji-picker'
import { ossMixin } from '../mixins'

export default {
  name: 'discuss-component',
  mixins: [ ossMixin ],
  props: {
    dataId: {
      type: String,
      required: true
    },
    dataState: String,
    defineId: String,
    formId: String
  },
  components: {
    VEmojiPicker
  },
  data () {
    return {
      inputEditorContent: '',
      inputVisible: false,
      editorFocus: false,
      emojiVisible: false,
      discuss: [],
      anchor: {
        range: null,
        node: null,
        startOffset: 0,
        endOffset: 0
      },
      // type: 1.文本；2、图文；3.附件文本
      type: 1,
      currentUserId: '',
      currentPreviewImgUrl: [],
      // 待上传文件
      needUploadFile: null,
      // 待上传图片的base64地址
      needUploadFileInfo: {
        src: '',
        name: '',
        size: 0
      }
    }
  },
  async created () {
    // 获取当前用户信息
    if (sessionStorage.getItem('currentUserId')) {
      this.currentUserId = sessionStorage.getItem('currentUserId')
    } else {
      this.currentUserId = await this.getCurrentUserId()
      sessionStorage.setItem('currentUserId', this.currentUserId)
    }
    // 讨论新建的时候不请求
    if (this.dataState !== 'create') {
      await this.getFormDiscuss('init')
      this.$nextTick(() => {
        let _this = this
        // 滚动到最下方
        if (this.$refs.discussContent) {
          this.$refs.discussContent.scrollTop = this.$refs.discussContent.scrollHeight
          // 监听content的滚动事件，触顶加载历史数据
          this.$refs.discussContent.addEventListener('scroll', _this.$_.debounce((e) => {
            // 如果滚动到了顶部且现在的数据量小于总数则去请求历史数据
            if (e.target.scrollTop === 0 && this.discuss.length < this.total) {
              this.getFormDiscuss('history')
            }
          }, 100))
        }
      })
    }
  },
  methods: {
    getCurrentUserId () {
      return this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
        return res.data.id
      })
    },
    handleDiscussData (discuss) {
      // todo: 处理附件的展示
      let afterHandleDiscuss = {
        text: discuss.text,
        dataId: discuss.dataId,
        formId: discuss.formId,
        from: discuss.from,
        fromName: discuss.fromName,
        createdDate: discuss.createdDate ? moment(discuss.createdDate).format('YYYY年MM月DD日 HH:mm:ss') : '',
        id: discuss.id
      }
      if (discuss.text.match(/\$\^\$.+\$\.\$/g)) {
        let fileUrl = discuss.text.match(/\$\^\$.+\$\.\$/g)[0].replace(/(\$\^\$)|(\$\.\$)/g, '')
        // 处理图文类型的消息
        if (discuss.type === 2) {
          afterHandleDiscuss.hasImage = true
        }
        // 处理附件类型的消息
        if (discuss.type === 3) {
          afterHandleDiscuss.hasAttachment = true
        }
        afterHandleDiscuss.fileName = discuss.fileName
        afterHandleDiscuss.fileSize = discuss.fileSize
        afterHandleDiscuss.fileUrl = `${sessionStorage.getItem('ossDownloadUrl')}/${fileUrl}`
        afterHandleDiscuss.text = afterHandleDiscuss.text.replace(/\$\^\$.+\$\.\$/g, '')
      }
      return afterHandleDiscuss
    },
    getFormDiscuss (type) {
      // 默认获取最新的50条信息， 新信息push，历史信息unshift（后端要求从1开始）
      let start = 0
      let size = 50
      // 如果是新发消息只要获取最前面的消息就可以了，防止网络不好用户发送太快有消息漏掉，所以这里获取最新的10条
      if (type === 'newMsg') {
        start = 0
        size = 10
      } else if (type === 'history') {
        // 历史每次获取30条数据
        start = this.discuss.length
        size = 30
      }
      let params = {
        size: size,
        filters: {
          start: start
        }
      }
      return this.$axios.get(`/form-api/discuss/${this.dataId}`, { params: params }).then(res => {
        if (res.data.items) {
          let currentDiscuss = []
          let newDiscuss = res.data.items.reverse().map(this.handleDiscussData)
          if (type === 'newMsg') {
            currentDiscuss = this.$_.concat(this.discuss, newDiscuss)
          } else if (type === 'history') {
            currentDiscuss = this.$_.concat(newDiscuss, this.discuss)
          } else {
            currentDiscuss = newDiscuss
          }
          this.total = res.data.total
          this.discuss = this.$_.uniqBy(currentDiscuss, 'id')
          this.$emit('setDiscussCount', this.total)
        }
      })
    },
    // 插入表情或图片（一个html块）
    insertNode (node) {
      this.$refs.inputEditor.focus()
      let s = window.getSelection()
      s.removeAllRanges()
      s.addRange(this.anchor.range)
      let r = s.getRangeAt(0)
      r.setStart(this.anchor.node, this.anchor.startOffset)
      r.setEnd(this.anchor.node, this.anchor.endOffset)
      r.deleteContents()
      r.insertNode(node)
      r.collapse(false)
    },
    // 选择emoji表情
    selectEmoji (emoji) {
      this.emojiVisible = false
      let emojiNode = document.createTextNode(emoji.data)
      this.$nextTick(() => {
        this.insertNode(emojiNode)
      })
    },
    // 展示输入编辑器
    showInputEditor () {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.inputEditor.focus()
      })
    },
    // 输入编辑器聚焦
    inputEditorFocus () {
      this.editorFocus = true
    },
    // 记录失焦前光标的锚点
    getAnchorRange (e) {
      this.editorFocus = false
      let s = window.getSelection()
      if (s.rangeCount) {
        this.anchor.range = s.getRangeAt(0)
        this.anchor.node = s.anchorNode
        this.anchor.startOffset = s.anchorOffset
        this.anchor.endOffset = s.focusOffset
      }
    },
    // 点击内容栏时输入编辑器失焦
    hideInputEditor (e) {
      if (e.target.className === 'discuss-content' || e.target.className === 'discuss') {
        if (this.inputVisible && this.$refs.inputEditor.innerText === '') {
          this.editorFocus = false
          this.inputVisible = false
          this.emojiVisible = false
        }
      }
    },
    // 点击工具栏
    clickToolBar () {
      this.editorFocus = false
    },
    // 编辑器栏里预览要上传的文件
    previewNeedUploadFile (file, toolsType) {
      this.needUploadFileInfo.name = file.name
      this.needUploadFileInfo.size = file.size
      let type = file.name.split('.').pop()
      let allowType = ['png', 'jpg', 'jpeg', 'gif']
      if (toolsType === 'image' && allowType.some(n => n === type.toLocaleLowerCase())) {
        // 图片类型的渲染一个图片节点插入. 预览用
        let img = document.createElement('img')
        img.style.maxWidth = '160px'
        img.className = 'attachment input-editor-image'
        let fr = new FileReader()
        let _this = this
        fr.readAsDataURL(file.raw)
        fr.onload = () => {
          _this.type = 2
          img.src = fr.result
          _this.insertNode(img)
        }
      } else if (toolsType === 'attach') {
        this.type = 3
        // 创建附件的预览元素
        let attachDiv = document.createElement('div')
        let attachSpan = document.createElement('span')
        let attachI = document.createElement('i')
        let attachInput = document.createElement('input')
        attachDiv.className = 'attachment input-editor-attach'
        attachSpan.contentEditable = false
        attachSpan.title = file.name
        attachI.className = 'fa fa-paperclip'
        attachInput.value = file.name
        attachInput.disabled = true
        attachSpan.append(attachI, attachInput)
        attachDiv.append(attachSpan)
        this.insertNode(attachDiv)
      }
    },
    changeFile (file, toolsType) {
      // todo: 有时不展示图片和附件的问题
      // 暂时限制只能传100M以下的文件
      if (file.size > 100 * 1024 * 1024) {
        this.$message.warning('超过100M大小限制')
        return false
      }
      if (toolsType === 'image') {
        let type = file.name.split('.').pop()
        let allowType = ['png', 'jpg', 'jpeg', 'gif']
        if (!allowType.some(n => n === type.toLocaleLowerCase())) {
          this.$message.warning('请上传图片类型文件')
          return false
        }
      }
      this.needUploadFile = file
      this.previewNeedUploadFile(file, toolsType)
    },
    uploadFile (file) {
      let key = this.getOssKey('USER', file.name)
      let url = sessionStorage.getItem('ossDownloadUrl')
      let formData = this.getUploadFormData(key, file)
      return this.$axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.status === 200) {
          return key
        }
      })
    },
    // 发送消息前先提交附件
    async handleAttachment (text) {
      // 通过检查是否有附件元素来判断是否有附件
      let attachNode = this.$refs.inputEditor.querySelector('.attachment')
      if (!attachNode) {
        this.type = 1
        return text
      }
      // 上传附件
      let fileUrl = await this.uploadFile(this.needUploadFile.raw)
      // 用$^$来做文件路径的开始标记，$.$做文件的结束标记
      return `${text}$^$${fileUrl}$.$`
    },
    // 发送消息
    async postMsg () {
      let text = this.$refs.inputEditor.innerText
      text = await this.handleAttachment(text)
      if (text === '' || text === undefined) {
        return null
      }
      if (this.isPosting) {
        this.$message.warning('消息发送中，请稍候...')
        return null
      }
      this.isPosting = true
      if (!this.anchor.range) {
        // 没有range的操作锚点的时候手动获取一下(防止第一次直接就用快捷键提交的时候没有)
        this.getAnchorRange()
      }
      // type: 1.文本；2、图文；3.附件文本
      let data = {
        dataId: this.dataId,
        defineId: this.defineId,
        formId: this.formId,
        text: text,
        type: this.type
      }
      if (this.type === 2 || this.type === 3) {
        // 有图文或者附件的时候传附件的名字和大小
        data.fileName = this.needUploadFile.name
        // 文件小于10kb时大小统一存储为0.01Mb
        data.fileSize = this.$_.round(this.needUploadFile.size / 1024 / 1024, 2) || 0.01
      }
      this.$axios.post(`/form-api/discuss`, data).then(async res => {
        // 使用range清除输入框的内容
        this.$refs.inputEditor.innerHTML = ''
        // 重置锚点为起点
        this.anchor.startOffset = 0
        this.anchor.endOffset = 0
        // 重置聚焦节点为输入框
        this.anchor.node = this.$refs.inputEditor
        this.type = 1
        this.isPosting = false
        await this.getFormDiscuss('newMsg')
        this.$nextTick(() => {
          this.inputEditorEditable = false
          // 滚动到最下方
          this.$refs.discussContent.scrollTop = this.$refs.discussContent.scrollHeight
        })
      }).catch(() => {
        this.isPosting = false
      })
    },
    deleteDiscuss (id) {
      this.$axios.delete(`/form-api/discuss/${id}`).then(res => {
        let index = this.discuss.findIndex(d => d.id === id)
        if (index !== -1) {
          this.discuss.splice(index, 1)
          this.total = this.total - 1
          this.$emit('setDiscussCount', this.total)
        }
      })
    },
    // 预览图片
    previewImage (url) {
      this.$emit('discuss-preview-image', url)
    },
    // 下载附件
    downloadAttachment (fileUrl) {
      const x = new XMLHttpRequest()
      x.open('GET', fileUrl, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = '附件'
        a.click()
        window.URL.revokeObjectURL(url)
      }
      x.onerror = function () {
        window.open(fileUrl)
      }
      x.send()
    }
  }
}
</script>

<style lang="scss">
  .form-discuss-content{
    height: 100%;
    padding-bottom: 132px;
    position: relative;
    .discuss-content{
      height: 100%;
      overflow-y: scroll;
      .discuss{
        border-bottom: 1px solid #DBDBDB;
        margin-bottom: 20px;
        &:hover{
          .header .delete{
            display: inline;
          }
        }
        .header{
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          height: 14px;
          span{
            font-size: 12px;
          }
          .creator{
            color: var(--primary, #55ACF1);
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .delete{
            display: none;
            color: #767D80;
            cursor: pointer;
            &:hover{
              color: var(--primary, #55ACF1);
            }
          }
        }
        .content{
          color: #2C2C2C;
          font-size: 12px;
          margin-bottom: 10px;
          cursor: pointer;
          .content-image{
            position: relative;
            &:hover{
              .img-name{
                display: inline;
              }
              .content-image-modal{
                display: block;
              }
            }
            .content-image-modal{
              pointer-events: none;
              display: none;
              width: 100%;
              height: 100%;
              position: absolute;
              z-index: 1;
              background-color: #000000;
              opacity: .7;
            }
            .img-name{
              display: none;
              position: absolute;
              left: 5px;
              top: 5px;
              z-index: 1;
              color: #ffffff;
            }
          }
          .content-attachment{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 167px;
            height: 104px;
            position: relative;
            background-color: #F7FBFE;
            &:hover{
              box-shadow: 0 0 300px rgba(0, 0, 0, .7) inset;
              .content-attachment-filename{
                color: #ffffff;
                top: 5px;
              }
              .content-attachment-filesize{
                display: inline-block;
                position: absolute;
                color: #ffffff;
                left: 10px;
                bottom: 5px;
              }
              .el-icon-bottom{
                display: inline-block;
              }
              .fa.fa-paperclip{
                filter: grayscale(40%);
              }
            }
            .el-icon-bottom{
              display: none;
              width: 18px;
              height: 16px;
              border-radius: 2px;
              text-align: center;
              line-height: 16px;
              position: absolute;
              right: 10px;
              bottom: 5px;
              color: #666666;
              background-color: #ffffff;
              &:hover{
                color: var(--primary, #55ACF1);
              }
            }
            .content-attachment-filesize{
              display: none;
              font-size: 12px;
            }
            .content-attachment-filename{
              position: absolute;
              left: 10px;
              bottom: 5px;
              font-size: 12px;
              color: #2C2C2C;
            }
            .fa.fa-paperclip{
              font-size: 28px;
              color: var(--primary, #55ACF1);
            }
          }
        }
        .date{
          font-size: 12px;
          color: #767D80;
          margin-bottom: 15px;
        }
      }
      .discuss-empty{
        display: flex;
        flex-direction: column;
        margin-top: 80px;
        align-items: center;
        img{
          margin-bottom: 15px;
        }
        span{
          color: #767D80;
          font-size: 12px;
        }
      }
      .discuss-input{
        text-align: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background-color: var(--light-bg-1, #F7FBFE);
        padding: 10px 0 5px;
        ::-webkit-scrollbar-track{
          background-color: var(--light-bg-1, #F7FBFE);
        }
        &.discuss-input-editor{
          height: 132px;
          border: 1px solid #DBDBDB;
          border-radius: 4px;
          padding: 10px 12px;
          &.discuss-input-editor-focus{
            border-color: var(--primary, #54ABF1);
          }
        }
        .el-input {
          height: 36px;
          input{
            &::-webkit-input-placeholder{
              color: #D3D4D4;
            }
            &::-ms-input-placeholder{
              color: #D3D4D4;
            }
          }
        }
        .input-editor{
          height: calc(100% - 36px);
          border-radius: 4px;
          text-align: left;
          color: #2C2C2C;
          outline: none;
          font-size: 12px;
          overflow-y: scroll;
          -webkit-user-modify: read-write-plaintext-only;
          .input-editor-attach{
            display: inline-block;
            width: 182px;
            height: 36px;
            line-height: 36px;
            span{
              display: inline-block;
              width: 180px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-left: 10px;
              border: 1px solid #E7EAED;
              background-color: #F1F4F9;
              input{
                width: 140px;
                outline: none;
                border: none;
                text-overflow: ellipsis;
              }
            }
            .fa{
              margin-right: 8px;
            }
          }
        }
        .input-editor-tools{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 6px;
          border-top:1px solid #DBDBDB;
          .tools{
            .discuss-upload{
              display: inline-block;
              margin-left: 15px;
            }
            span{
              color: #2C2C2C;
              cursor: pointer;
              &:hover{
                color: var(--primary, #54ABF1);
              }
            }
          }
          .el-button{
            width: 56px;
            height: 24px;
            padding: 0;
          }
        }
      }
    }
  }
  .emoji-popover{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/discussLogComponents/discuss-component.vue